/**
 *
 * @param {Date} date
 * @returns {string}
 */
export const toLocalDateString = (date) =>
  date.toISOString().split("T")[0];
